export default __webpack_public_path__ + "static/media/header-bg-kalendar-3.f56c153b.jpg";